import { Fade } from '@progress/kendo-react-animation'
import { SvgIcon } from '@progress/kendo-react-common'
import { Window } from '@progress/kendo-react-dialogs'
import { DropDownList } from '@progress/kendo-react-dropdowns'
import { Stepper } from '@progress/kendo-react-layout'
import { Notification, NotificationGroup } from '@progress/kendo-react-notification'
import React, { useCallback, useEffect, useState } from 'react'

import { fetchSendDocumentation } from '../../features/forms/formsAPI'
import { TextInputModal } from '../../GlobalComponents/GenericModals/GenericModals'
import {
    getCompanyFromURL,
    getCookie,
    isLocalhost,
    logEvent,
} from '../../GlobalComponents/GlobalFunctions'
import AWCWinningTogetherLogo from '../../GlobalComponents/_icons/AWCWinningTogetherLogo.svg'
import { AWCButton, BUTTON_TYPES, FastQuoteInput } from '../../GlobalComponents/Inputs/Inputs'
import { fqAlert } from '../../GlobalComponents/NotificationManager/NotificationManager'
import { getAPIURL, getBaseURL } from '../../GlobalComponents/URLs'
import {
    DefaultDocumentType,
    DefaultDocumentTypeBlue,
    DefaultDocumentTypeGray,
    Drawing,
    DrawingBlue,
    DrawingGray,
    SizingCalc,
    SizingCalcBlue,
    SizingCalcGray,
    SpecSheet,
    SpecSheetBlue,
    SpecSheetGray,
    TestReport,
    TestReportBlue,
    TestReportGray,
} from '../SVGIcons'
import styles from './CustomerTag.module.scss'
import { useMediaQuery } from 'react-responsive'

let qsSearch = window.location.search
let qsParams = new URLSearchParams(qsSearch)
let qsTagUID = qsParams.get('u')

const webUsername = getCookie('WebUsername')
let walkThruCookie = getCookie('WalkThruId')

let isLoggedIn = !!walkThruCookie

function iconMapMobile(value) {
    let icon = undefined
    if (isLoggedIn) {
        switch (value) {
            case 'Drawing':
                icon = DrawingBlue
                break
            case 'SpecSheet':
            case 'Cust Provided Spec Sheet':
            case 'Spec Sheet':
                icon = SpecSheetBlue
                break
            case 'SizingCalc':
            case 'Sizing Calculations':
                icon = SizingCalcBlue
                break
            case 'Test Report':
            case 'BenchMark Report':
                icon = TestReportBlue
                break
            default:
                icon = DefaultDocumentTypeBlue
        }
    } else {
        switch (value) {
            case 'Drawing':
                icon = DrawingGray
                break
            case 'SpecSheet':
            case 'Cust Provided Spec Sheet':
            case 'Spec Sheet':
                icon = SpecSheetGray
                break
            case 'SizingCalc':
            case 'Sizing Calculations':
                icon = SizingCalcGray
                break
            case 'Test Report':
            case 'BenchMark Report':
                icon = TestReportGray
                break
            default:
                icon = DefaultDocumentTypeGray
        }
    }
    return icon
}

function iconMap(value) {
    let icon = undefined

    switch (value) {
        case 'Drawing':
            icon = Drawing
            break
        case 'SpecSheet':
        case 'Cust Provided Spec Sheet':
        case 'Spec Sheet':
            icon = SpecSheet
            break
        case 'SizingCalc':
        case 'Sizing Calculations':
            icon = SizingCalc
            break
        case 'Test Report':
        case 'BenchMark Report':
            icon = TestReport
            break
        default:
            icon = DefaultDocumentType
    }

    return icon
}

const AssetRow = ({ assetField, assetValue }) => {
    return (
        <div style={{ display: 'flex' }}>
            <span style={{ paddingLeft: 10, fontWeight: '700', width: '40%', textAlign: 'start' }}>
                {assetField}
            </span>
            <span style={{ width: '60%', textAlign: 'start', maxWidth: 300 }}>{assetValue}</span>
        </div>
    )
}

const CustomerTagDocumentSection = ({ documentation }) => {
    documentation?.map((doc) => {
        if (!doc.OrderBy) {
            doc.OrderBy = 0
        }
        return doc
    })

    documentation?.sort((a, b) => a.OrderBy - b.OrderBy)

    let renderedOutput = documentation?.map((doc) => {
        return <CustomerTagDocument document={doc} />
    })

    return <div className={styles.documentSection}>{renderedOutput}</div>
}

const CustomerTagDocument = ({ document }) => {
    let iconSpan = ''
    if (document.Icon !== undefined) {
        if (document.Icon.startsWith('k-')) {
            iconSpan = (
                <span
                    className={document.Icon}
                    style={{
                        paddingBottom: '2px',
                        color: isLoggedIn ? '#0080ff' : '#B7B7B7',
                    }}
                />
            )
        } else {
            let icon = iconMapMobile(document.DocTypeName)
            iconSpan = (
                <SvgIcon
                    icon={icon}
                    style={{
                        paddingBottom: '2px',
                        fill: isLoggedIn ? '#0080ff' : '',
                    }}
                />
            )
        }
    }
    return (
        <div
            style={{ color: isLoggedIn ? '#0080ff' : '#B7B7B7' }}
            onClick={() =>
                isLoggedIn
                    ? window.open(document.URL)
                    : fqAlert({
                        type: 'error',
                        message: 'Please login to access document downloads.',
                        title: 'Login Required',
                    })
            }
            className={styles.document}
        >
            <div>{iconSpan}</div>
            <div style={{ paddingTop: 5 }}>{document.DocTypeName || 'Test Report'}</div>
        </div>
    )
}

export default function CustomerTag({
    orderTagID,
    onClose,
    // tagWindowVisible,
    handleMobileAssetView,
}) {
    const [data, setData] = useState({})
    const [warehouse, setWarehouse] = useState({})
    const [selectedDocument, setSelectedDocument] = useState({
        Name: 'Document Download',
        Icon: 'k-icon k-i-file',
        URL: '',
    })

    useEffect(() => {
        walkThruCookie = getCookie('WalkThruId')
        isLoggedIn = !!walkThruCookie
    }, [document.cookie])

    useEffect(() => {
        logEvent({
            eventName: 'Insight QR Scan',
            string2: webUsername,
            decimal1: parseInt(qsTagUID),
        })
    }, [])

    const detailWindow = React.useRef()
    const [throbberDocumentationDownload, setThrobberDocumentationDownload] = useState({
        status: 'stand-by',
        isExporting: false,
    })

    const greenBlueShop = [
        'Automated On-Off Valve',
        'Control Valve',
        'Control Valve - Globe',
        'Control Valve - Rotary',
        'Manual Valve',
        'Motor Operated Valve',
        'Other',
        'Other Valves',
        'Control Valve',
    ]
    // API Calls----------------------------------------------------------------

    // Get Customer Tag
    React.useEffect(() => {
        var apiParams = { orderTagID: orderTagID, tagUID: qsTagUID }
        if (orderTagID > -1 || qsTagUID !== null) {
            let tree_url = getAPIURL() + 'lcm/customertag'
            fetch(tree_url, {
                credentials: 'include',
                method: 'post',
                body: JSON.stringify(apiParams),
                headers: isLoggedIn
                    ? { 'Content-type': 'application/json' }
                    : { 'Content-type': 'application/json', Company: getCompanyFromURL() },
            })
                .then((resp) => {
                    if (resp.ok) {
                        return resp.json()
                    } else throw new Error('bad request ' + resp.statusText)
                })
                .then((json) => {
                    if (json.CustomerTag !== undefined) {
                        // Convert date fields to JSON date fields
                        json.CustomerTag.OrderDate = new Date(json.CustomerTag.OrderDate)
                        json.CustomerTag.NeedDate = new Date(json.CustomerTag.NeedDate)
                        if (
                            json.CustomerTag.DateReceived !== null &&
                            json.CustomerTag.DateReceived !== undefined
                        )
                            json.CustomerTag.DateReceived = new Date(json.CustomerTag.DateReceived)
                        if (
                            json.CustomerTag.PlannedDeliveryDate !== null &&
                            json.CustomerTag.PlannedDeliveryDate !== undefined
                        )
                            json.CustomerTag.PlannedDeliveryDate = new Date(
                                json.CustomerTag.PlannedDeliveryDate
                            )
                        if (
                            json.CustomerTag.DateTested !== null &&
                            json.CustomerTag.DateTested !== undefined
                        )
                            json.CustomerTag.DateTested = new Date(json.CustomerTag.DateTested)
                        setData(json)
                    } else {
                        setData([])
                    }
                })
        }
    }, [orderTagID])

    // Get warehouse when data changes
    useEffect(() => {
        if (data && data.CustomerTag) {
            let warehouse_url =
                getAPIURL() +
                `WarehouseGet/WarehouseGet/${data.CustomerTag.AllocationWarehouse
                    ? data.CustomerTag.AllocationWarehouse.trim()
                    : '01'
                }`
            fetch(warehouse_url, {
                credentials: 'include',
                method: 'GET',
                headers: isLoggedIn
                    ? { 'Content-type': 'application/json' }
                    : { 'Content-Type': 'application/json', Company: getCompanyFromURL() },
            })
                .then((resp) => {
                    if (resp.ok) {
                        return resp.json()
                    } else throw new Error('bad request ' + resp.statusText)
                })
                .then((json) => {
                    setWarehouse(json)
                })
        }
    }, [data])

    const closeDialog = useCallback(() => {
        //function closeDialog() {
        qsTagUID = null // clear query string... use has viewed tag
        //set orderTagID to -1 to allow reopenning of same tag
        //setOrderTagID(-1);
        onClose()
    }, [onClose])

    React.useEffect(() => {
        if (data.CustomerTag !== undefined && data.CustomerTag.TagUID !== undefined) {
            if (true) {
                //if (!tagWindowVisible) {
                // detailWindow.current.windowElement.style.left = `max(0px, calc(50vw - ${detailWindow.current.windowElement.clientWidth / 2}px))`;
                // detailWindow.current.windowElement.style.top = `max(0px, calc(50vh - ${detailWindow.current.windowElement.clientHeight / 2}px))`;

                // To close window from modal veil...
                if (detailWindow.current) {
                    let overlayElement =
                        detailWindow.current.windowElement.parentNode.querySelector('.k-overlay')
                    overlayElement.addEventListener('click', closeDialog)
                }
            }

            // // To close window from modal veil...
            // let overlayElement =
            //     detailWindow.current.windowElement.parentNode.querySelector('.k-overlay')
            // overlayElement.addEventListener('click', closeDialog)
        }
    }, [data.CustomerTag, closeDialog])

    // Stepper - limit to only assets and services supported by team
    let stepper = <div></div>
    let milestoneItems = []
    let milestoneValue = -1
    if (data.Milestones !== undefined) {
        for (var i in data.Milestones) {
            milestoneItems.push({
                label: data.Milestones[i].Milestone,
                icon: data.Milestones[i].Icon,
            })
            if (data.Milestones[i].Selected) milestoneValue = parseInt(i)
        }
    }
    if (milestoneItems.length > 0 && milestoneValue !== -1)
        stepper = <Stepper value={milestoneValue} items={milestoneItems} />

    function onDocumentSelectionChange(event) {
        // setSelectedDocument(data.CustomerTag.Documentation[event.target.index]);
        if (event.value.URL !== undefined && event.value.URL.length > 0) {
            window.open(event.value.URL)
        }
    }

    // // Mobile First
    // let windowStyle = {
    //     left: '0px',
    //     top: '0px',
    //     width: '100%',
    //     height: 'auto',
    //     maxHeight: 'calc(100vh - 80px)',
    // } // Leave space for website header
    // // let windowStyle = { width: "100%", height: "auto", maxHeight: "calc(100vh - 80px)" }; // Leave space for website header
    // let titleStyle = {
    //     width: '100%',
    //     fontSize: 15,
    //     lineHeight: '1.3em',
    //     display: 'grid',
    //     gridTemplateColumns: 'auto',
    // }
    // let dataStyle = { display: 'grid', gridTemplateColumns: '100%' }
    // let dataLabelStyle = {
    //     fontWeight: '500',
    //     width: '40%',
    //     textAlign: 'right',
    //     padding: '0px 5px 6px 0px',
    // }
    // let afDataLabelStyle = dataLabelStyle
    // //let docStyle = {display: "grid", gridTemplateColumns: "100%"};
    // //let docLabelStyle = {width: "30%",fontWeight: "500", textAlign: "right", paddingRight: "5px"};
    // let docDDLStyle = { width: '200px' }

    // if (true) { //if (!tagWindowVisible) {
    let windowStyle = { minWidth: '90%', height: 'auto' }
    // windowStyle = {minWidth: '85%', minHeight:'58vh'};
    let titleStyle = {
        width: '100%',
        fontSize: 18,
        lineHeight: '1.3em',
        display: 'grid',
        gridTemplateColumns: 'auto auto auto auto',
    }
    // dataStyle = {
    //     display: 'grid',
    //     height: '25vh',
    //     gridTemplateColumns: '50% 50%',
    //     gridTemplateRows: '12% 12% 12% 12% 12% 12% 12% 12%',
    //     gridAutoFlow: 'column',
    // }
    let dataStyle = { display: 'block', paddingBottom: '15px', paddingTop: '15px' }
    // dataLabelStyle = {
    //     fontWeight: '500',
    //     width: '40%',
    //     textAlign: 'right',
    //     paddingRight: '5px',
    // }
    let dataLabelStyle = {
        fontWeight: '500',
        // height: "22px",
        width: '40%',
        textAlign: 'right',
        paddingRight: '5px',
    }
    let afDataLabelStyle = {
        fontWeight: '500',
        // height: "32px",
        width: '40%',
        textAlign: 'right',
        padding: '0px 3px 0px 3px',
    }
    //docStyle = {display: "grid", gridTemplateColumns: "100%"};
    //docLabelStyle = {width: "15%",fontWeight: "500", textAlign: "right", paddingRight: "5px"};
    let docDDLStyle = { width: '300px', zIndex: 'inherit' }
    // }

    function tagData(label, customerTagData, type) {
        if (customerTagData !== undefined && customerTagData.toString() !== '') {
            let sData = customerTagData
            if (sData.length > 35) sData = sData.substring(0, 35)
            if (type === 'Date') sData = customerTagData.toLocaleDateString('en-US')
            if (type === 'Boolean') sData = customerTagData.toString()
            if (type.startsWith('URL'))
                sData = (
                    <a
                        href={type.substring(3)}
                        style={{ color: '#0080FF', textDecoration: 'none' }}
                        target="_blank"
                        rel="noreferrer"
                    >
                        {customerTagData}{' '}
                        <span
                            className="k-icon k-i-hyperlink-open"
                            style={{ fontSize: 12, marginBottom: 2 }}
                        />
                    </a>
                )
            return (
                <div style={{ display: 'flex', width: '100%' }}>
                    <div style={dataLabelStyle}>{label}:</div>
                    <div style={{ width: '60%' }}>{sData}</div>
                </div>
            )
        }
    }

    function assetFieldData(label, customerTagData, type) {
        if (customerTagData !== undefined && customerTagData.toString() !== '') {
            let sData = customerTagData
            if (sData.length > 35) sData = sData.substring(0, 35)
            if (type === 'Date') sData = customerTagData.toLocaleDateString('en-US')
            if (type === 'Boolean') sData = customerTagData.toString()
            if (type.startsWith('URL'))
                sData = (
                    <a href={type.substring(3)} target="_blank" rel="noreferrer">
                        {customerTagData}
                    </a>
                )
            return (
                <div>
                    <div
                        style={{
                            display: 'flex',
                            fontSize: 'smaller',
                            width: '100%',
                            borderRight: '1px solid lightGrey',
                        }}
                    >
                        <div style={afDataLabelStyle}>{label}:</div>
                        <div style={{ width: '60%', display: 'flex', alignItems: 'end' }}>
                            {sData}
                        </div>
                        {/* <div style={{ width: "60%" }}>{sData}</div> */}
                    </div>
                    <div
                        style={{
                            height: 15,
                            fontSize: 'smaller',
                            width: '100%',
                            borderRight: '1px solid lightGrey',
                        }}
                    ></div>
                </div>
            )
        }
    }

    let AssetFields = []
    for (let i in data.AssetFields) {
        let fieldName = data.AssetFields[i].field
        AssetFields.push(
            assetFieldData(
                data.AssetFields[i].title,
                data.CustomerTag[fieldName],
                data.AssetFields[i].fieldType
            )
        )
    }

    function getAssetFields(assetFields) {
        let tempFields = []
        for (let i in assetFields) {
            let fieldName = assetFields[i].field

            tempFields.push(
                assetFieldData(
                    assetFields[i].title,
                    data.CustomerTag[fieldName],
                    assetFields[i].fieldType
                )
            )
        }

        return tempFields
    }

    function ddlValueRender(element, value) {
        let iconSpan = ''
        if (value !== undefined) {
            //value.Icon = "k-icon icon-default-document-type";
            //value.Icon = "k-icon icon-test-report";
            if (value.Icon.startsWith('k-')) {
                iconSpan = <span className={value.Icon} style={{ marginRight: 6 }} />
            } else {
                let icon = iconMap(value.DocTypeName)
                iconSpan = (
                    <div>
                        <SvgIcon icon={icon} style={{ marginRight: 6 }} />
                    </div>
                )
            }
        }
        const valueChildren = (
            <span
                style={{
                    display: 'flex',
                    alignItems: 'center',
                    width: '100%',
                    margin: 2,
                }}
            >
                {iconSpan}
                {element.props.children}
            </span>
        )
        return React.cloneElement(element, { ...element.props }, valueChildren)
    }

    function ddlItemRender(li, itemProps) {
        let iconSpan = ''
        if (itemProps.dataItem.Icon !== undefined) {
            //itemProps.dataItem.Icon = "k-icon icon-default-document-type";
            //itemProps.dataItem.Icon = "k-icon icon-test-report";
            //itemProps.dataItem.Icon = "icon icon-Drawing";
            //itemProps.dataItem.Icon = "SpecSheet";
            if (itemProps.dataItem.Icon.startsWith('k-')) {
                iconSpan = <span className={itemProps.dataItem.Icon} style={{ marginRight: 6 }} />
            } else {
                let icon = iconMap(itemProps.dataItem.DocTypeName)
                iconSpan = <SvgIcon icon={icon} style={{ marginRight: 6 }} />
            }
        }
        let downloadIcon = ''
        if (itemProps.dataItem.URL !== '')
            downloadIcon = (
                <span
                    className="k-icon k-i-download"
                    style={{
                        color: '#0080ff',
                        cursor: 'pointer',
                        fontWeight: 500,
                    }}
                ></span>
            )
        const itemChildren = (
            <span
                style={{
                    display: 'flex',
                    alignItems: 'center',
                    width: '100%',
                    margin: 2,
                }}
            >
                {iconSpan}
                <span style={{ display: 'flex', flex: 1, textDecoration: 'none' }}>
                    {li.props.children}
                </span>
                {downloadIcon}
            </span>
        )
        return React.cloneElement(li, li.props, itemChildren)
    }

    function singleItemRender() {
        let iconSpan = ''
        if (document.Icon !== undefined) {
            if (data.CustomerTag.Documentation[0].Icon.startsWith('k-')) {
                iconSpan = (
                    <span
                        className={data.CustomerTag.Documentation[0].Icon}
                        style={{ marginRight: 6, paddingBottom: '2px' }}
                    />
                )
            } else {
                let icon = iconMap(data.CustomerTag.Documentation[0].DocTypeName)
                iconSpan = <SvgIcon icon={icon} style={{ marginRight: 6, paddingBottom: '2px' }} />
            }
        }
        let downloadIcon = ''
        if (data.CustomerTag.Documentation[0].URL !== '')
            downloadIcon = (
                <span
                    className="k-icon k-i-download"
                    style={{
                        paddingBottom: '2px',
                        color: '#0080ff',
                        cursor: 'pointer',
                        fontWeight: 500,
                    }}
                ></span>
            )

        return (
            <div style={{ display: 'flex', padding: '3px 0px 8px 0px' }}>
                <div>{iconSpan}</div>
                <div>
                    <a
                        href={data.CustomerTag.Documentation[0].URL}
                        style={{
                            display: 'block',
                            textOverflow: 'ellipsis',
                            overflow: 'hidden',
                            whiteSpace: 'nowrap',
                            width: 250,
                            textDecoration: 'none',
                            color: '#0080FF',
                        }}
                        target="_blank"
                        rel="noreferrer"
                    >
                        {data.CustomerTag.Documentation[0].Name}
                    </a>
                </div>
                <div style={{ paddingLeft: '10px', paddingRight: '15px' }}>{downloadIcon}</div>
            </div>
        )
    }
    function downloadDocumentation(apiParams) {
        let genDoc_url = getAPIURL() + 'lcm/generateDocumentationZip'
        setThrobberDocumentationDownload({
            status: 'Downloading',
            isDownloading: true,
        })
        fetch(genDoc_url, {
            credentials: 'include',
            method: 'post',
            body: JSON.stringify(apiParams),
            headers: { 'Content-type': 'application/json' },
        })
            .then((resp) => {
                if (resp.ok) {
                    return resp.json()
                } else throw new Error('bad request ' + resp.statusText)
            })
            .then((json) => {
                if (json.errorMessage.length === 0) {
                    setThrobberDocumentationDownload({
                        status: 'Success',
                        isDownloading: false,
                    })
                    //window.location.href = json.url;  Don't use!  //Causes unloading with message
                    window.open(json.url)
                } else {
                    setThrobberDocumentationDownload({
                        status: 'Error',
                        isDownloading: false,
                    })
                    alert(json.errorMessage)
                }
            })
            .catch((e) => {
                setThrobberDocumentationDownload({
                    status: 'Error',
                    isDownloading: false,
                })
                alert(e.message)
            })
    }
    const downloadAll = () => {
        let params = {
            orderTagIds: [orderTagID],
            reportTypes: [],
        }
        downloadDocumentation(params)
    }

    // const [assetTypeFieldGroupHeaders, setAssetType]
    const [attributeGroupHeaders, setAttributeGroupHeaders] = useState([])

    const [isMobileView, setIsMobileView] = useState(qsTagUID === null ? false : true)

    const AttributeColumn = (props) => {
        return (
            <div
                style={{
                    borderRight: props.index !== props.maxColumnIndex && '1px solid lightGrey',
                    height: 400,
                }}
            >
                <div
                    style={{
                        backgroundColor: '#f0f0f0',
                        borderBottom: '1px solid lightGrey',
                        fontWeight: 500,
                        padding: 10,
                        borderCollapse: 'collapse',
                        textAlign: 'center',
                    }}
                >
                    {props.title}
                </div>
                <div
                    style={{
                        paddingTop: 10,
                        overflowY: 'auto',
                        overflowX: 'hidden',
                        maxHeight: 350,
                    }}
                >
                    {props.title === 'Valve' && <MfgModelNumberDivs />}
                    {props.assetFields}
                </div>
            </div>
        )
    }

    useEffect(() => {
        if (data.CustomerAssetTypeFieldGroups) {
            setAttributeGroupHeaders(
                data.CustomerAssetTypeFieldGroups.map((header) => {
                    return header.GroupName
                })
            )
        }
    }, [data])

    const MfgModelNumberDivs = () => {
        return (
            <>
                {assetFieldData('Mfg', data.CustomerTag.ValveManufacturer, 'String')}
                {assetFieldData('Model #', data.CustomerTag.ValveModelNo, 'String')}
            </>
        )
    }

    const loginForCompleteDetails = () => {
        if (isLocalhost) {
            document.cookie = 'WalkThruId=Test'
        }
        let redirectURL = getAPIURL().replace('/webapi/', '') + '/logon.aspx'
        if (redirectURL.toUpperCase().includes('NET'))
            redirectURL = getAPIURL().replace('/webapi/', '') + '/masterclient/main.aspx'
        let originalURL = window.location.href
        window.location.href = redirectURL + '?Redirect=' + encodeURIComponent(originalURL)
    }

    const [sendDocumentModalOpen, setSendDocumentModalOpen] = useState(false)

    const handleSendDocumentEmailSubmit = async (email) => {
        const resp = await fetchSendDocumentation({ TagUID: data.CustomerTag.TagUID, Email: email })
        if (!resp) {
            fqAlert({
                type: 'success',
                message: 'Email successfully sent.',
            })
        } else {
            fqAlert({
                type: 'error',
                message: `${resp}`,
                title: 'Email could not be sent.',
            })
        }
    }

    if (isMobileView) {
        return (
            <div style={{ textAlign: 'center', padding: '25px 12px' }}>
                {data.CustomerTag && (
                    <div>
                        <div style={{ fontSize: 12, fontWeight: 500 }}>
                            <img
                                src={AWCWinningTogetherLogo}
                                alt="AWC Winning Together"
                                width={150}
                                onClick={() => {
                                    window.open(getBaseURL())
                                }}
                                style={{ cursor: 'pointer' }}
                            />
                            <div>
                                {warehouse.phone ? (
                                    <a href={`tel:${warehouse.phone}`}>{warehouse.phone}</a>
                                ) : (
                                    'No phone on file'
                                )}
                            </div>
                            <div style={{ paddingTop: 5 }}>
                                {warehouse.SalesEmail ? (
                                    <a href={`mailto:${warehouse.SalesEmail}`}>
                                        {warehouse.SalesEmail}
                                    </a>
                                ) : (
                                    'No email on file'
                                )}
                            </div>
                        </div>
                        <div className={styles.container}>
                            <hr className={styles.tagDivider} />
                            <div className="zebra">
                                <div className={styles.row}>
                                    <AssetRow
                                        assetField={'Tag #'}
                                        assetValue={data.CustomerTag.Tag}
                                    />
                                </div>
                                <div className={styles.row}>
                                    <AssetRow
                                        assetField={'Sales Order #'}
                                        assetValue={data.CustomerTag.OrderNumber}
                                    />
                                </div>
                                <div className={styles.row}>
                                    <AssetRow
                                        assetField={'Customer P.O.'}
                                        assetValue={data.CustomerTag.CustomerOrderNumber}
                                    />
                                </div>
                                <div className={styles.row}>
                                    <AssetRow
                                        assetField={'Serial #'}
                                        assetValue={data.CustomerTag.SerialNumber}
                                    />
                                </div>
                                <div className={styles.row}>
                                    <AssetRow
                                        assetField={'AWC ID'}
                                        assetValue={data.CustomerTag.TagUID}
                                    />
                                </div>
                            </div>
                            <hr className={styles.tagDivider} />
                            {greenBlueShop.includes(data.CustomerTag.AssetType) ? (
                                <div className="zebra">
                                    {data.CustomerTag.ValveManufacturer && (
                                        <div className={styles.row}>
                                            <AssetRow
                                                assetField={'Valve Mfg.'}
                                                assetValue={data.CustomerTag.ValveManufacturer}
                                            />
                                        </div>
                                    )}
                                    {data.CustomerTag.ValveModelNo && (
                                        <div className={styles.row}>
                                            <AssetRow
                                                assetField={'Valve Model #'}
                                                assetValue={data.CustomerTag.ValveModelNo}
                                            />
                                        </div>
                                    )}
                                    {data.CustomerTag.ActuatorManufacturer && (
                                        <div className={styles.row}>
                                            <AssetRow
                                                assetField={'Actuator Mfg.'}
                                                assetValue={data.CustomerTag.ActuatorManufacturer}
                                            />
                                        </div>
                                    )}
                                    {data.CustomerTag.ActuatorModelNo && (
                                        <div className={styles.row}>
                                            <AssetRow
                                                assetField={'Actuator Model #'}
                                                assetValue={data.CustomerTag.ActuatorModelNo}
                                            />
                                        </div>
                                    )}
                                    {data.CustomerTag.PositionerManufacturer && (
                                        <div className={styles.row}>
                                            <AssetRow
                                                assetField={'Positioner Mfg.'}
                                                assetValue={data.CustomerTag.PositionerManufacturer}
                                            />
                                        </div>
                                    )}
                                    {data.CustomerTag.PositionerModelNo && (
                                        <div className={styles.row}>
                                            <AssetRow
                                                assetField={'Positioner Model #'}
                                                assetValue={data.CustomerTag.PositionerModelNo}
                                            />
                                        </div>
                                    )}
                                    {data.CustomerTag.LimitSwitchMfgModel && (
                                        <div className={styles.row}>
                                            <AssetRow
                                                assetField={'Limit Switch/Xmtr Mfg.'}
                                                assetValue={data.CustomerTag.LimitSwitchMfgModel}
                                            />
                                        </div>
                                    )}
                                    {data.CustomerTag.LimitSwitchModel && (
                                        <div className={styles.row}>
                                            <AssetRow
                                                assetField={'Limit Switch/Xmtr Model #'}
                                                assetValue={data.CustomerTag.LimitSwitchModel}
                                            />
                                        </div>
                                    )}
                                    {data.CustomerTag.SolenoidManufacturer && (
                                        <div className={styles.row}>
                                            <AssetRow
                                                assetField={'Solenoid Mfg.'}
                                                assetValue={data.CustomerTag.SolenoidManufacturer}
                                            />
                                        </div>
                                    )}
                                    {data.CustomerTag.SolenoidModel && (
                                        <div className={styles.row}>
                                            <AssetRow
                                                assetField={'Solenoid Model #'}
                                                assetValue={data.CustomerTag.SolenoidModel}
                                            />
                                        </div>
                                    )}
                                </div>
                            ) : (
                                <div className="zebra">
                                    {data.CustomerTag.ValveManufacturer && (
                                        <div className={styles.row}>
                                            <AssetRow
                                                assetField={'Mfg.'}
                                                assetValue={data.CustomerTag.ValveManufacturer}
                                            />
                                        </div>
                                    )}
                                    {data.CustomerTag.ValveModelNo && (
                                        <div className={styles.row}>
                                            <AssetRow
                                                assetField={'Model #'}
                                                assetValue={data.CustomerTag.ValveModelNo}
                                            />
                                        </div>
                                    )}
                                </div>
                            )}
                            <div
                                style={{
                                    display: 'flex',
                                    paddingTop: 20,
                                    gap: 10,
                                    paddingLeft: 10,
                                }}
                            >
                                <span
                                    style={{
                                        fontWeight: '700',
                                    }}
                                >
                                    Description:
                                </span>
                                <span
                                    style={{
                                        overflowWrap: 'break-word',
                                        textAlign: 'left',
                                        inlineSize: '75%',
                                    }}
                                >
                                    {data.CustomerTag.Description}
                                </span>
                            </div>
                            <hr className={styles.tagDivider} />

                            <div style={{ marginTop: 20 }}>
                                <b>Document Download</b>
                                <CustomerTagDocumentSection
                                    documentation={data.CustomerTag.Documentation}
                                />
                            </div>

                            <div
                                style={{
                                    marginTop: 50,
                                    display: 'flex',
                                    justifyContent: 'center',
                                }}
                            >
                                <AWCButton
                                    type={
                                        isLoggedIn ? BUTTON_TYPES.SECONDARY : BUTTON_TYPES.DISABLED
                                    }
                                    style={{ width: 400 }}
                                    onClick={
                                        isLoggedIn
                                            ? () => {
                                                setSendDocumentModalOpen(true)
                                            }
                                            : () => {
                                                fqAlert({
                                                    type: 'error',
                                                    message: 'Please login to send reports.',
                                                    title: 'Login Required',
                                                })
                                            }
                                    }
                                >
                                    <span
                                        className="k-icon k-i-email"
                                        style={{ marginRight: 5 }}
                                    ></span>
                                    Send All Reports
                                </AWCButton>
                            </div>

                            <div
                                style={{
                                    marginTop: 20,
                                    display: 'flex',
                                    justifyContent: 'center',
                                }}
                            >
                                <AWCButton
                                    type={BUTTON_TYPES.PRIMARY}
                                    style={{ width: 400 }}
                                    onClick={
                                        isLoggedIn
                                            ? () => {
                                                handleMobileAssetView(true)
                                            }
                                            : () => {
                                                loginForCompleteDetails()
                                            }
                                    }
                                >
                                    {isLoggedIn ? (
                                        <span>Manage all Assets</span>
                                    ) : (
                                        <span>Login for complete details</span>
                                    )}
                                </AWCButton>
                            </div>
                        </div>
                    </div>
                )}
                <TextInputModal
                    open={sendDocumentModalOpen}
                    title={'Send All Reports to:'}
                    cancelText={'Cancel'}
                    submitText={'Send'}
                    onSubmit={handleSendDocumentEmailSubmit}
                    close={() => setSendDocumentModalOpen(false)}
                />
            </div>
        )
    }

    // Render-------------------------------------------------------------------
    return (
        <div>
            {data.CustomerTag !== undefined && data.CustomerTag.TagUID !== undefined && (
                <Window
                    ref={detailWindow}
                    modal={true}
                    draggable={true}
                    initialLeft={0.05 * window.innerWidth}
                    // initialTop={0.5 * (window.innerHeight - 800)}
                    initialTop={0.05 * window.innerHeight}
                    // initialLeft={`calc(50% - ${window.innerWidth / 2})`}
                    // initialTop={`calc(50% - ${window.innerHeight / 2})`}
                    title={
                        <div style={titleStyle}>
                            <div>AWC ID: {data.CustomerTag.TagUID}</div>
                            <div>Tag Number: {data.CustomerTag.Tag}</div>
                            <div>Process Unit: {data.CustomerTag.ProcessUnit}</div>
                            <div>Serial Number: {data.CustomerTag.SerialNumber}</div>
                        </div>
                    }
                    visible={false}
                    onClose={closeDialog}
                    style={windowStyle}
                    // width={'85%'}
                    minimizeButton="false"
                    maximizeButton="false"
                    doubleClickStageChange={false}
                >
                    <div
                        style={{
                            fontSize: '1.05em',
                            fontWeight: '500',
                            paddingBottom: '10px',
                        }}
                    >
                        Asset Type: {data.CustomerTag.AssetType}
                    </div>
                    {stepper}
                    <div>&nbsp;</div>
                    <div
                        style={{
                            display: 'grid',
                            gridTemplateColumns: '30% 70%',
                            // height: "56vh",
                            gap: 10,
                        }}
                    >
                        <div>
                            <div
                                style={{
                                    ...dataStyle,
                                    borderStyle: 'solid',
                                    borderColor: 'lightgray',
                                    borderWidth: 'thin',
                                    width: '100%',
                                    height: 305,
                                    marginBottom: 10,
                                }}
                            >
                                {tagData('Site', data.CustomerTag.Site, 'String')}
                                {tagData(
                                    'Purchase Order #',
                                    data.CustomerTag.CustomerOrderNumber,
                                    'String'
                                )}
                                {tagData(
                                    'AWC Sales Order',
                                    data.CustomerTag.OrderNumber,
                                    data.CustomerTag.OrderURL !== undefined &&
                                        data.CustomerTag.OrderURL.length > 0
                                        ? 'URL' + data.CustomerTag.OrderURL
                                        : 'String'
                                )}
                                {tagData('Order Date', data.CustomerTag.OrderDate, 'Date')}
                                {tagData('Asset Received', data.CustomerTag.DateReceived, 'Date')}
                                {/* {tagData("Date Requested", data.CustomerTag.NeedDate, "Date")} */}
                                {tagData(
                                    'Planned Delivery',
                                    data.CustomerTag.PlannedDeliveryDate,
                                    'Date'
                                )}
                                {tagData('Date Tested', data.CustomerTag.DateTested, 'Date')}
                                {tagData('Turnaround', data.CustomerTag.ProjectName, 'String')}
                                {tagData('Service', data.CustomerTag.ServiceType, 'String')}
                                {tagData('Disposition', data.CustomerTag.Disposition, 'String')}
                                {tagData('Milestone', data.CustomerTag.Milestone, 'String')}
                                {tagData('Stage', data.CustomerTag.Stage, 'String')}
                                {tagData('Error', data.CustomerTag.AuthorizationRequired, 'String')}
                            </div>
                            {data.CustomerTag.Documentation !== undefined &&
                                data.CustomerTag.Documentation.length > 0 && (
                                    <div
                                        style={{
                                            width: '100%',
                                            borderStyle: 'solid',
                                            borderColor: 'lightgray',
                                            borderWidth: 'thin',
                                            paddingTop: 17,
                                            paddingBottom: 17,
                                        }}
                                    >
                                        <div
                                            style={{
                                                width: '100%',
                                                display: 'flex',
                                                justifyContent: 'center',
                                                paddingBottom: '5px',
                                                paddingTop: '5px',
                                            }}
                                        >
                                            <div
                                                style={{
                                                    width: 300,
                                                    display: 'flex',
                                                    justifyContent: 'space-between',
                                                }}
                                            >
                                                <div
                                                    style={{
                                                        fontWeight: '500',
                                                        width: '40%',
                                                        paddingLeft: '5px',
                                                        textAlign: 'right',
                                                        whiteSpace: 'nowrap',
                                                    }}
                                                >
                                                    Document Download
                                                </div>
                                                {data.CustomerTag.Documentation.length > 1 && (
                                                    <div
                                                        onClick={() => downloadAll()}
                                                        style={{
                                                            color: '#0080ff',
                                                            cursor: 'pointer',
                                                            fontWeight: 500,
                                                        }}
                                                    >
                                                        <span className="k-icon k-i-download" />{' '}
                                                        <span>
                                                            Download All (
                                                            {data.CustomerTag.Documentation.length})
                                                        </span>
                                                    </div>
                                                )}
                                            </div>
                                        </div>
                                        <div
                                            style={{
                                                width: '100%',
                                                display: 'flex',
                                                justifyContent: 'center',
                                            }}
                                        >
                                            {data.CustomerTag.Documentation.length === 1 &&
                                                singleItemRender()}
                                            <div onClick={() => downloadAll()}></div>
                                            {data.CustomerTag.Documentation.length > 1 && (
                                                <DropDownList
                                                    style={docDDLStyle}
                                                    data={data.CustomerTag.Documentation}
                                                    textField="Name"
                                                    dataItemKey="URL"
                                                    onChange={onDocumentSelectionChange}
                                                    valueRender={ddlValueRender}
                                                    itemRender={ddlItemRender}
                                                    value={{
                                                        Name: 'Document Download',
                                                        Icon: 'k-icon k-i-file',
                                                        URL: '',
                                                    }}
                                                />
                                            )}
                                        </div>
                                    </div>
                                )}
                        </div>

                        <div
                            style={{
                                borderStyle: 'solid',
                                borderColor: 'lightgray',
                                borderWidth: 'thin',
                                marginRight: 10,
                            }}
                        >
                            <div
                                style={{
                                    height: '40px',
                                    lineHeight: '40px',
                                    fontWeight: '500',
                                    paddingLeft: '10px',
                                    backgroundColor: '#E6E6E6',
                                    borderBottomStyle: 'solid',
                                    borderBottomColor: 'lightgray',
                                    borderBottomWidth: 'thin',
                                    textAlign: 'center',
                                }}
                            >
                                Attributes
                            </div>
                            {data.CustomerAssetTypeFieldGroups ? (
                                <div
                                    style={{
                                        display: 'inline-grid',
                                        gridAutoFlow: 'column',
                                        width: '100%',
                                        gridAutoColumns: 'minmax(0, 1fr)',
                                    }}
                                >
                                    {attributeGroupHeaders.map((title, index) => {
                                        let tempFields = []
                                        for (let index in data.AssetFields) {
                                            if (data.AssetFields[index].GroupName === title) {
                                                tempFields.push(data.AssetFields[index])
                                            }
                                        }
                                        return (
                                            <AttributeColumn
                                                title={title}
                                                index={index}
                                                maxColumnIndex={attributeGroupHeaders.length - 1}
                                                assetFields={getAssetFields(tempFields)}
                                            />
                                        )
                                    })}
                                </div>
                            ) : (
                                <div
                                    style={{
                                        display: 'grid',
                                        gridTemplateColumns: 'auto auto auto',
                                        gridAutoFlow: 'column',
                                        paddingTop: '10px',
                                        gridTemplateRows: 'auto auto auto auto auto auto auto auto',
                                    }}
                                >
                                    <MfgModelNumberDivs />
                                    {AssetFields}
                                </div>
                            )}
                        </div>
                    </div>
                </Window>
            )}
            <NotificationGroup
                style={{
                    right: 0,
                    bottom: 20,
                    alignItems: 'flex-start',
                    flexWrap: 'wrap-reverse',
                }}
            >
                <Fade enter={true} exit={true}>
                    {throbberDocumentationDownload.status === 'Success' && (
                        <Notification
                            type={{ style: 'success', icon: true }}
                            closable={true}
                            onClose={() =>
                                setThrobberDocumentationDownload({
                                    status: 'stand-by',
                                    isDownloading: false,
                                })
                            }
                        >
                            <span>Your documentation has been downloaded.</span>
                        </Notification>
                    )}
                </Fade>
            </NotificationGroup>
        </div>
    )
}
